import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.trouble-ticket';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTroubleTicketEffects {

    TroubleTicket$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_TROUBLE_TICKET),
        mergeMap((x: ac.GetTroubleTicketAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getTroubleTicket(x.troubleticket_id).pipe(
                map((result: any) => {
                    return new ac.GetTroubleTicketErfolgreichAction(result, x.troubleticket_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetTroubleTicketFehlerAction(error, x.troubleticket_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketQueryService);
        }
        return this.service;
    }
}
